module.exports = __webpack_public_path__ + "img/sniper.b8c20e25.png";